module.exports = __webpack_public_path__ + "img/UKC-1867.b993b3bb.png";